import { CircleAlert } from "lucide-react";
import { toast } from "react-toastify";
import { catchExceptionCallbackBody } from "resbutler-utils/utils/errorUtils";

type CatchExceptionCallback = (error, selectedLanguage?: string) => string;

export const ErrorToast = ({ heading, body }: { heading?: string; body?: string }) => (
  <div className="custom-error-toast d-flex align-items-start justify-content-start gap-2">
    <CircleAlert size={18} className="toast-alert-icon" />
    <div>
      {heading && <div className="toast-heading">{heading}</div>}
      {body && <div className="toast-body-text">{body}</div>}
    </div>
  </div>
);

// helper to dispatch error toast for caught api errors
export const catchExceptionCallback: CatchExceptionCallback = (error, selectedLanguage = "en") => {
  console.error(error);

  const [errorBody, errorHeading] = catchExceptionCallbackBody(error, selectedLanguage);

  toast.error(<ErrorToast heading={errorHeading} body={errorBody} />, {
    autoClose: 3000,
    theme: "dark",
    closeButton: true,
    icon: false,
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    className: "toast-error-shell",
  });

  return errorBody;
};

export const Result = ({ children }) => <div className="result">{children}</div>;

export const ErrorResult = ({ children }) => <div className="fv-help-block">{children}</div>;
